import React from 'react';
import { equals, pick, prop } from 'ramda';
import VerticalGamesView from './VerticalGamesView';
import { useAppSelector, useDeviceSelector } from '../../../../../store/hooks';

const GamesView = (props) => {
    const { gameCodes, isShowGameName, isShowPlayButtonOnHover, trackChangeGameClick } = props;
    let gamesSupportedByPortal = useAppSelector(prop('games'));
    const deviceSelector = useDeviceSelector(pick(['isLandscape', 'isMobile', 'isTablet', 'isDesktop']));

    // gamesSupportedByPortal could came null.
    if (gamesSupportedByPortal == null) {
        gamesSupportedByPortal = [];
    }
    const withAvailableGames = () => {
        const availableGames = gameCodes.filter(code => gamesSupportedByPortal[code]);
        const isEqual = equals(availableGames, gameCodes);
        return {
            gameCodes: isEqual ? gameCodes : availableGames
        };
    };
    return <div>
        <VerticalGamesView gameCodes={withAvailableGames().gameCodes} deviceSelector={deviceSelector}
                           isShowGameName={isShowGameName} isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                           trackChangeGameClick={trackChangeGameClick}/>
    </div>;
};

export default GamesView;
